import styled from 'styled-components'

export const AndDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;

  p {
    font-weight: bold;
  }
`
